export function sanitizeContent(content: any) {
  return JSON.parse(JSON.stringify(content)
  .replace(/\uFEFF/g, ""))
}